export default __webpack_public_path__ + "static/hero-bg2-a161e38bd9c41dfad271ee34e81be485.jpg";